import { useCallback } from "react";

import { urlBackend } from "@/shared";
import { genericFetch } from "@/shared/hooks/genericFetch";
import { erpApi } from "@/shared/axios";
import { ClienteSoftnet, ClienteSoftnetPagingRes } from "../interfaces/contratos.interface";


export const USE_TODOS = 'TODOS'
const BASE_URL_REPORTS = `${urlBackend}api/v1/reports/`;

///* fetch para el autcomplete

const { get } = erpApi();

const fetchAutocompleteGeneric = async<
    TOption,
    TResponse extends { data: TOption[]; next?: string | null; count?: number }
>(
    url: string,
): Promise<{ options: TOption[]; hasMore: boolean }> => {

    const response = await get<TResponse>(`${url}`, true);
    const data = response.data;

    // Calcular hasMore basándose en la respuesta del backend
    // Si hay campo 'next', usarlo; si no, verificar si recibimos datos
    const hasMore = data.next != null || (data.data?.length ?? 0) >= 10;

    return {
        options: data.data as TOption[],
        hasMore: hasMore && (data.data?.length ?? 0) > 0,
    };
};

export default function useAutocompleteClienteSoftnetFetch() {


    const fetchAutocompleteClienteSoftnet = useCallback(
        (
            search: string,
            page: number,
            isAll: boolean,
            keySearch: keyof ClienteSoftnet = 'nombre_cliente',
            params: Partial<ClienteSoftnet>,
        ) => {
            return genericFetch<
                ClienteSoftnet,
                Partial<ClienteSoftnet>,
                keyof ClienteSoftnet & string
            >({
                baseUrl: `${BASE_URL_REPORTS}contratos`,
                fetchFn: (url) =>
                    fetchAutocompleteGeneric<ClienteSoftnet, ClienteSoftnetPagingRes>(url),
                search,
                page,
                isAll,
                keySearch: keySearch as keyof ClienteSoftnet & string,
                params: {
                    ...params
                },
            });
        },
        [BASE_URL_REPORTS],
    );

    return {
        fetchAutocompleteClienteSoftnet
    }

}